// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Message } from 'semantic-ui-react';
// local
// import t from 'app/utils/i18n';
// stylesheets
import styles from './NotificationOverlay.module.scss';

class NotificationOverlay extends Component {
  render() {
    let { isError, errors, header = null, icon = '', size = 'mini' } = this.props.options;
    let content = null;
    let list = null;
    if (isError) {
      if (!errors) {
        return null;
      }
      if (errors.length > 1) {
        header = 'Alguns erros foram encontrados:';
        list = errors.map(item => item.key);
      } else {
        const item = errors[0];
        const isThereErrorMessage = item && item.key; /*  && item.data */
        content = isThereErrorMessage ? item.key : 'Erro indefinido';
      }
    } else {
      content = errors;
    }

    return (
      <Message
        size={size}
        className={styles.overlayNotification}
        header={header}
        error={isError}
        content={content}
        list={list}
        onDismiss={this.handleDismiss}
        icon={icon}
      />
    );
  }
}

NotificationOverlay.propTypes = {
  options: PropTypes.object
  // icon: PropTypes.string,
  // errors: PropTypes.any,
  // isError: PropTypes.bool,
  // header: PropTypes.string
};

export default NotificationOverlay;
